module.exports = __webpack_public_path__ + "img/prize-01.2dea5831.png";